import { sendToVcars } from './vcarsEndpoint';

export interface Lead {
  name: string;
  phone: string;
  email: string;
  reason: 'buy' | 'tradeIn';
  vehicle: string;
  message: string;
  tradeInVehicle?: {
    marca: string;
    modelo: string;
    anio: string;
    kilometraje: string;
    estadoGeneral: string;
  };
}

export async function submitLead(lead: Lead): Promise<void> {
  const base = {
    nombre: lead.name.trim(),
    telefono: lead.phone.trim(),
    email: lead.email.trim(),
    vehiculoInteres: lead.vehicle,
    mensaje: lead.message.trim(),
  };

  if (lead.reason === 'tradeIn') {
    await sendToVcars('permuta', { ...base, ...(lead.tradeInVehicle ?? {}) });
    return;
  }

  await sendToVcars('consulta', { ...base, motivo: 'Quiero comprar un auto' });
}
